<template>
    <div class="md-cta-sc standard" :style="{ marginBottom }">
        <banner
            ref="banner"
            :class="{
                'mg-container': !fullColumn,
                'mobile-no-margin': mobileNoMargin
            }"
            :style="
                showOpacityLayer
                    ? {
                        paddingTop: verticalMargin + 'px',
                        paddingBottom: verticalMargin + 'px'
                    }
                    : {}
            "
            type="single"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :maskOption="maskOption"
        >
            <media-content
                :class="{ showLayer: showOpacityLayer }"
                :style="
                    showOpacityLayer
                        ? { width: `calc(100% - ${2 * HorizontalMargin}px)` }
                        : {}
                "
                type="text"
                :title="title"
                :titleSize="30"
                :subTitle="subTitle"
                :subTitleSize="18"
                :showShadow="false"
            >
                <banner-button
                    :size="16"
                    :style="{ justifyContent: buttonAlign }"
                    :buttons="buttons"
                    @callback="showRegisterPop"
                ></banner-button>
                <div
                    v-if="showOpacityLayer"
                    class="content-mask"
                    :style="{ backgroundColor: contentColor }"
                ></div>
            </media-content>
        </banner>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common]
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-cta-sc.standard {
    .banner {
        flex-direction: column;
    }
    .media-content {
        flex: 1;
        position: relative;
        justify-content: center;
        width: 800px;
        max-width: calc(100% - 40px);
        min-width: auto;
        padding: 0;
        &.showLayer {
            width: calc(100% - 160px);
            min-width: 600px;
            max-width: none;
            padding: 40px 60px;
        }
        .media-info {
            width: 100%;
        }
        .title-text {
            width: 100%;
            padding-bottom: 5px;
            text-align: center;
            .media-title {
                font-size: 30px;
                line-height: 1.33;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                @include webkitBox(3);
            }
            .media-subtitle {
                font-size: 18px;
                line-height: 1.11;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }
        }
        .banner-button {
            font-size: 16px;
            .btn-item {
                min-width: 260px;
                border-radius: 2px;
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
                border: none;
                max-width: 100%;
                padding: 0 40px;
                @include ellipsis();
                font-size: 1em;
                line-height: 40px;
                font-family: var(--mg-button-font);
                text-shadow: none;
            }
        }
        .content-mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: -1;
        }
        @include media-800 {
            &.showLayer {
                min-width: 400px;
            }
        }
        @include media-600 {
            max-width: calc(100% - 30px);
            &.showLayer {
                max-width: calc(100% - 30px);
                padding: 30px 20px;
                min-width: 320px;
            }
            .title-text {
                .media-title {
                    font-size: 24px;
                    line-height: normal;
                }
                .media-subtitle {
                    font-size: 14px;
                    line-height: 1.43;
                }
            }
            .banner-button {
                font-size: 14px;
            }
        }
    }
}
</style>
